<template>
    <PanelItem :index="index" :field="fieldValue"/>
</template>

<script>
export default {
    props: ['index', 'resource', 'resourceName', 'resourceId', 'field'],

    computed: {
        fieldValue() {
            if (this.field.value) {
                this.field.asHtml = true
                this.field.value = `<span dir="ltr">${this.field.value}</span>`
            }

            return this.field
        },
    },
}
</script>
